import { render, staticRenderFns } from "./imageEditor.vue?vue&type=template&id=2fb4f73e"
import script from "./imageEditor.vue?vue&type=script&lang=js"
export * from "./imageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports